import { render } from "./OrderShow.vue?vue&type=template&id=32a716cf&scoped=true"
import script from "./OrderShow.vue?vue&type=script&lang=js"
export * from "./OrderShow.vue?vue&type=script&lang=js"

import "./OrderShow.vue?vue&type=style&index=0&id=32a716cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a716cf"]])

export default __exports__